import { render } from "./DiscordLogin.vue?vue&type=template&id=23089904&scoped=true"
import script from "./DiscordLogin.vue?vue&type=script&lang=js"
export * from "./DiscordLogin.vue?vue&type=script&lang=js"

import "./DiscordLogin.vue?vue&type=style&index=0&id=23089904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23089904"]])

export default __exports__